// extracted by mini-css-extract-plugin
module.exports = {"l1uyj04i":"l1uyj04i","fadeIn":"fadeIn","d1kwgnpz":"d1kwgnpz"};